module.exports = __webpack_public_path__ + "static/media/service-window-order-date-2.1ecfeadc.png";